import { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { setEntryPoint, clearEntryPoint } from "./modules/Session/actions";
import AnalyticsProvider from "./components/AnalyticsProvider";
import useIframeResize from "./hooks/useIframeResize";
import { trackFunnelDropoff, getSessionContext } from "./utils/analytics";

function MainApp({ children }) {
	const dispatch = useDispatch();
	useIframeResize();

	// Get booking state to check if completed
	const confirmedAppointments = useSelector(
		(state) => state.booking?.confirmedAppointments || []
	);

	useEffect(() => {
		// On initial mount we want to store the entry point of the app
		// in the redux store so that we can use it later
		// to determine if we should show the login screen or not
		dispatch(setEntryPoint());

		// Track funnel drop-off when user leaves without completing booking
		const handleBeforeUnload = () => {
			const session = getSessionContext();
			// Only track dropoff if user was in a step and didn't complete booking
			if (session.currentStep && confirmedAppointments.length === 0) {
				trackFunnelDropoff('page_close');
			}
		};

		// Track when user navigates away or closes tab
		window.addEventListener('beforeunload', handleBeforeUnload);

		// Also track visibility changes (tab switch, minimize)
		const handleVisibilityChange = () => {
			if (document.hidden) {
				const session = getSessionContext();
				if (session.currentStep && confirmedAppointments.length === 0) {
					trackFunnelDropoff('tab_hidden');
				}
			}
		};
		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			dispatch(clearEntryPoint());
			window.removeEventListener('beforeunload', handleBeforeUnload);
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [confirmedAppointments.length]);

	return <AnalyticsProvider>{children}</AnalyticsProvider>;
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(MainApp);
